import React, { Component } from "react";
import imgLoading from "../../../assets/itemLoading.gif";

class Imgloading extends Component {
  state = {
    loading: true,
    onError: false,
  };

  handleLoad = () => {
    this.setState({ loading: false });
  };

  handleError = () => {
    this.setState({ loading: false, onError: true });
  };

  render() {
    const { Img } = this.props;

    return (
      <>
        {this.state.loading && <img src={imgLoading} alt="loading" />}
        <img
          src={Img}
          alt="item"
          onLoad={this.handleLoad}
          onError={this.handleError}
          style={this.state.onError ? { display: "none" } : {}}
          loading="lazy"
        />
        {this.state.onError && <img src={imgLoading} alt="error" />}
      </>
    );
  }
}

export default Imgloading;
